<div class="container">
  <div class="titleBox">
    <div class="headerText">Team Videos</div>
    <div class="subText">
      <a [routerLink]="['/']">
        <fa-icon icon="home"></fa-icon>
      </a>
      / All Videos
    </div>
  </div>

  <div class="box">
    <div class="actionRow">
      <div class="filter">
        <mat-form-field>
          <input matInput (keyup)="applyFilter($event.target.value)" />
          <mat-label>Filter</mat-label>
        </mat-form-field>
      </div>
      <div class="addButton">
        <a [href]="exportUrl" [download]="exportFilename" mat-flat-button color="primary" class="link_button" (click)="exportCsv()" matTooltip="Download Team Results data">
          <mat-icon>cloud_download</mat-icon>
        </a>
        <button mat-flat-button color="primary" (click)="getResults()">
          <fa-icon icon="sync-alt" [animation]="isLoading ? 'spin' : undefined" class="button_text"></fa-icon>
        </button>
      </div>
    </div>

  </div>

  <div class="mat-elevation-z4 scrollable_table">
      <table mat-table [dataSource]="isLoading ? skeletonRows : dataSource" matSort>
        <ng-container matColumnDef="cre_date">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            Created
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.cre_date | date: "M/d/yy" }}<br />{{
              row.cre_date | date: "h:mm a"
              }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="brand_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Brand </th>
          <td mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{row.brand_name || clientName }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Team Member</th>
          <td mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.first_name }} {{ row.last_name }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="video_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.display_name }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.email }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="salesmail">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            SalesMail
          </th>
          <td style="padding: 10px" class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              <div class="centeredCell thumbnailBtn">
                <a (click)="showVideo(row)">
                  <div class="centeredCell thumbnailBorder">
                    <img class="thumbnail" src="{{ row.thumbnail_url }}" alt="SalesMail" />
                    <mat-icon class="playIcon">play_circle_outline</mat-icon>
                  </div>
                </a>
                <div class="video_len">{{ row.video_length | videoLength }}</div>
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="length">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            Length
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.video_length | videoLength }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="shares">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="share-from-square" matTooltip="Total Shares"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.Shares }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="opens">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="envelope-open" matTooltip="Opens"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.Opens }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="views">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="eye" matTooltip="Views"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.Views }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="comments">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="comment-dollar" matTooltip="Comments"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.comment_count }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="ctas">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="bullhorn" matTooltip="CTA Clicks"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.cta_count }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="reactions">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef mat-sort-header>
            <fa-icon icon="thumbs-up" matTooltip="Reactions"></fa-icon>
          </th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              {{ row.reaction_count }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="short_url">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef>Copy</th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              <button class="primary-color" mat-icon-button matTooltip="Copy Short URL" ngxClipboard
                (click)="copyToClipboard(row.short_url)">
                <fa-icon class="fa_icon" [icon]="['fas', 'copy']"></fa-icon>
              </button>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="send">
          <th class="centeredCell" mat-header-cell *matHeaderCellDef>Share</th>
          <td class="centeredCell" mat-cell *matCellDef="let row">
            @if (isLoading) {
              <div class="table-skeleton-row table-skeleton-row-text"></div>
            } @else {
              <button mat-icon-button class="primary-color" matTooltip="Share this SalesMail" ngxClipboard (click)="sendSalesMail(row)">
                <fa-icon icon="share"></fa-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr [ngClass]="{ 'disabled-background': (!isLoading && row?.disabled) || row?.user_disabled }" mat-row
        *matRowDef="let row; columns: tableColumns"></tr>
      </table>

      <div class="bottom-toolbar">
        @if (data && data.length > 0 && !isLoading) {
          <div class="bottom-toolbar-button-group">
            <mat-checkbox class="disabled_check" color="primary" [(ngModel)]="show_disabled" (change)="hideDisabledClick()">
              Show Deleted SalesMails
            </mat-checkbox>
            <mat-checkbox class="disabled_check" color="primary" [(ngModel)]="show_disabled_users" (change)="hideDisabledClick()">
              Show Deactivated Users' SalesMails
            </mat-checkbox>
          </div>
        }
        <mat-paginator pageSize="25" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
      </div>
    </div>
</div>